import CloseIcon from "@material-ui/icons/Close";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import firebase, {
  axiosWithToken,
  functionBaseUrl,
} from "../../../../common/firebase";
import ModalMobile from "../../../../components/shared/Modal/ModalMobile";
import PurchaseHistoryTable from "./PurchaseHistoryTable";
import Spinner from "../../../../components/shared/spinner/Spinner";

export const PurchaseHistoryModal = ({ isOpen, setIsOpen }) => {
  const [currentPage, setCurrentPage] = React.useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [purchaseHistoryData, setInvoices] = useState([]);

  const limit = 10;

  const purchaseHistory = purchaseHistoryData.slice(
    (currentPage - 1) * limit,
    currentPage * limit
  );

  const loadData = async () => {
    try {
      const firebaseUser = firebase.auth().currentUser;
      const userId = firebaseUser.uid;

      let response = await axiosWithToken(
        `${functionBaseUrl}/api/v1/credits/coach/${userId}`,
        {
          method: "GET",
        }
      );
      const result = response?.data?.credits
        .filter((el) => el.transactionType === "in")
        .sort((a, b) => b.createdAt - a.createdAt);

      setInvoices(result);
    } catch (error) {
      toast.error("Error loading purchase history");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) loadData();
  }, [isOpen]);

  return (
    <ModalMobile
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      className="p-6 sm:max-w-[480px] lg:max-w-[1128px] font-manrope"
    >
      <div className="w-full flex justify-between items-center">
        <div className="text-lg font-semibold text-gray700">
          Purchase History
        </div>
        <CloseIcon
          className="cursor-pointer"
          onClick={() => setIsOpen(false)}
        />
      </div>

      <div className="min-h-12 overflow-x-auto mt-6">
        {isLoading ? (
          <div className="flex items-center justify-center">
            <Spinner color="primary500" size="md" />
          </div>
        ) : (
          <PurchaseHistoryTable
            purchaseHistory={purchaseHistory}
            currentPage={currentPage}
            pageNumber={Math.ceil(purchaseHistoryData.length / limit)}
            onPageChange={(page) => setCurrentPage(page)}
          />
        )}
      </div>
    </ModalMobile>
  );
};
